import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IBatteryLevelChartProps {
  control: IControl;
  width: number;
  height: number;
}

const BatteryLevelChart = (props: IBatteryLevelChartProps) => {
  const { control, width, height } = props;
  const { value, valuesList } = useControlMeasurements(control, [
    "bat_energy_percent",
  ]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawPercentBars(ctx, valuesList[0]);
  };

  return (
    <MeasurementChart
      title={t("Battery Level") + `: ${value}%`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default BatteryLevelChart;
